<script lang="ts" setup>
  import { toRef, toRefs } from 'vue';
  import { useField } from 'vee-validate';
  import CurrencyInput from './CurrencyInput.vue';
  import type { TextInputFieldProps } from '../TextInput/TextInputField.vue';
  import { InputWidthVariant } from '../InputWrapper/';

  const props = withDefaults(defineProps<Omit<TextInputFieldProps, 'type'>>(), {
    rules: undefined,
    width: InputWidthVariant.MIN,
  });

  const {
    name: inputName,
    label,
    rules,
    ...rest
  } = toRefs<TextInputFieldProps>(props);

  const inputProps = toRef(rest);

  const {
    value: inputValue,
    errorMessage,
    handleBlur,
    handleChange,
    meta,
  } = useField<string>(inputName.value, rules?.value, {
    label: label?.value,
  });

  const onBlur = () => {
    handleBlur(undefined, true);
  };
</script>

<template>
  <CurrencyInput
    v-bind="inputProps"
    :error="errorMessage as string"
    :label="label"
    :meta="meta"
    :model-value="inputValue as string"
    :name="name"
    :width="width"
    :placeholder="placeholder"
    @blur="onBlur"
    @update:modelValue="handleChange"
  >
    <template #iconRight> <slot name="iconRight"></slot> </template>
    <template #inputLabel> <slot name="inputLabel"></slot> </template>
    <template #inputError> <slot name="inputError"></slot> </template>
    <template #iconLeft> <slot name="iconLeft"></slot> </template>
  </CurrencyInput>
</template>
